import request from '@/utils/request'

// 获取新增数据统计接口
export function getNewdata(query) {
    return request({
      url: '/com/shop/index/sum-data',
      method: 'get',
      params: query
    })
}

// 获取商品分析接口
export function getProductTrend(query) {
    return request({
      url: '/com/shop/index/product-trend',
      method: 'get',
      params: query
    })
}

// 订购询价数据分析图
export function getNewRegisterdata(query) {
    return request({
      url: '/com/shop/index/act-register',
      method: 'get',
      params: query
    })
}

// 获取申样统计接口
export function getNewSampledata(query) {
    return request({
      url: '/com/shop/index/act-sample',
      method: 'get',
      params: query
    })
}

  

 // 获得消息分页
 export function getStationMessagePage() {
    return request({
      url: '/com/shop/index/msg',
      method: 'get'
    })
  }

  export function getStationMessagePageData(query) {
    return request({
      url: '/system/shop/msg/page',
      method: 'get',
      params: query
    })
  }

  export function getBackGet(query) {
    return request({
        url: '/system/shop/msg/get-all-num',
        method: 'get',
        params: query
    })
}